import { tChallengeKey, tChallengeRole } from './ChallengeCenter.types';

/** i18n namespace served from public/locales/{lng}/challengeCenter/challengeCenter.json */
export const CHALLENGE_CENTER_NS = 'challengeCenter/challengeCenter';

/**
 * The dev-only controls (simulate a signal, advance the week, reset the demo)
 * never ship: the dev-trigger endpoint answers 403 in production anyway, this
 * keeps the buttons out of the DOM in every non-dev build. A function rather
 * than a constant so tests can mock the module and exercise both branches.
 */
export function isDevBuild(): boolean {
  return import.meta.env.DEV;
}

/**
 * The declarative catalog the SAD's section 06 describes: copy keys per
 * challenge_key. Adding challenge #9 is adding an entry here, never a bespoke
 * component. `title` and `done` are keys into CHALLENGE_CENTER_NS, resolved
 * with `t()` at render. Which signal completes each one lives in
 * workspace-service (ChallengeCenterService) and in the golden path doc.
 */
export const CHALLENGE_CATALOG: Record<tChallengeKey, { title: string; done: string }> = {
  connect_whatsapp: { title: 'catalog.connect_whatsapp.title', done: 'catalog.connect_whatsapp.done' },
  invite_team: { title: 'catalog.invite_team.title', done: 'catalog.invite_team.done' },
  review_stages: { title: 'catalog.review_stages.title', done: 'catalog.review_stages.done' },
  respond_lead: { title: 'catalog.respond_lead.title', done: 'catalog.respond_lead.done' },
  move_lead: { title: 'catalog.move_lead.title', done: 'catalog.move_lead.done' },
  send_bulk_template: { title: 'catalog.send_bulk_template.title', done: 'catalog.send_bulk_template.done' },
  attend_leads: { title: 'catalog.attend_leads.title', done: 'catalog.attend_leads.done' },
  verify_portfolio: { title: 'catalog.verify_portfolio.title', done: 'catalog.verify_portfolio.done' },
};

// Display order. The backend decides which rows exist (verify_portfolio is
// conditional); the panel renders whatever it gets, in this order.
export const OWNER_CATALOG: tChallengeKey[] = [
  'connect_whatsapp',
  'invite_team',
  'review_stages',
  'respond_lead',
  'move_lead',
  'send_bulk_template',
  'attend_leads',
  'verify_portfolio',
];
export const SELLER_CATALOG: tChallengeKey[] = ['respond_lead', 'move_lead', 'attend_leads'];

export function catalogForRole(role: tChallengeRole | null): tChallengeKey[] {
  return role === 'SELLER' ? SELLER_CATALOG : OWNER_CATALOG;
}
